export default {
    getAllNotifications: (state) => state.notifications,    
    getUnreadNotificationsCount: (state) => state.unreadNotificationsCount, 
    getReadNotificationsCount: (state) => state.readNotificationsCount,
    getUnreadNotifications: (state) => state.unreadNotifications,
    getReadNotifications: (state) => state.readNotifications,
    getIsLoadedState: (state) => state.isLoaded,
    getNotificationsCount: (state) => state.count,
  };